import { render, staticRenderFns } from "./grid.vue?vue&type=template&id=669b3790&scoped=true&lang=pug&"
import script from "./grid.vue?vue&type=script&lang=js&"
export * from "./grid.vue?vue&type=script&lang=js&"
import style0 from "./grid.vue?vue&type=style&index=0&id=669b3790&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669b3790",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('669b3790', component.options)
    } else {
      api.reload('669b3790', component.options)
    }
    module.hot.accept("./grid.vue?vue&type=template&id=669b3790&scoped=true&lang=pug&", function () {
      api.rerender('669b3790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/position/align/grid.vue"
export default component.exports